export default __webpack_public_path__ + "static/media/Meal_Food.9b065586.svg";